<template>
	<el-config-provider :locale="locale" :size="config.size" :zIndex="config.zIndex" :button="config.button">
		<router-view></router-view>
	</el-config-provider>
</template>

<script>
	import colorTool from '@/utils/color'
	export default {
		name: 'App',
		data() {
			return {
				config: {
					size: "default",
					zIndex: 2000,
					button: {
						autoInsertSpace: false
					}
				}
			}
		},
		computed: {
			locale(){
				return this.$i18n.messages[this.$i18n.locale].el
			},
		},
		created() {
			//设置主题颜色
			const app_color = this.$CONFIG.COLOR || this.$TOOL.data.get('APP_COLOR')
			const app_color_danger = this.$CONFIG.APP_COLOR_DANGER || this.$TOOL.data.get('APP_COLOR_DANGER')
			const app_color_success = this.$CONFIG.APP_COLOR_SUCCESS || this.$TOOL.data.get('APP_COLOR_SUCCESS')
			if(app_color){
				document.documentElement.style.setProperty('--el-color-primary', app_color);
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(app_color,i/10));
				}
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(app_color,i/10));
				}
			}
			if(app_color_danger){
				document.documentElement.style.setProperty('--el-color-danger', app_color_danger);
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-danger-light-${i}`, colorTool.lighten(app_color_danger,i/10));
				}
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-danger-dark-${i}`, colorTool.darken(app_color_danger,i/10));
				}
			}
			if(app_color_success){
				document.documentElement.style.setProperty('--el-color-success', app_color_success);
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-success-light-${i}`, colorTool.lighten(app_color_success,i/10));
				}
				for (let i = 1; i <= 9; i++) {
					document.documentElement.style.setProperty(`--el-color-success-dark-${i}`, colorTool.darken(app_color_success,i/10));
				}
			}
		},
    methods:{

    }
	}
</script>

<style lang="scss">
	@import '@/style/style.scss';
	
.el-table .el-table__cell {
  position: static;
}
.el-dialog__body {
 max-height: 60vh;
 overflow: hidden;
 overflow-y: auto;
}
.el-tabs__nav-wrap::after{
	background-color: transparent !important;
} 
</style>
